import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "role-manager-container"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  class: "blurred-background-with-overlay"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "role-list-info"
};
const _hoisted_6 = {
  class: "nickname"
};
const _hoisted_7 = {
  key: 0
};
import { computed, watch } from 'vue';
import store from '@/store';
import { Plus } from "@element-plus/icons-vue";
export default {
  __name: 'RoleManager',
  emits: ['open-role-generator'],

  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit; // computed

    const user = computed(() => store.state.user);
    const roleArray = computed(() => store.state.role_array ?? []);
    const selectedRole = computed(() => store.state.selected_role); // functions

    const selectedCard = role_id => {
      store.commit('update_selected_role', role_id);
    }; // watchers


    watch(() => roleArray.value, newVal => {
      if (newVal.length > 0 && selectedRole.value === null) {
        store.commit('update_selected_role', newVal[0].id);
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");

      const _component_el_icon = _resolveComponent("el-icon");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleArray.value, (role, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(['role-list-card', {
            'is-selected': role.id === selectedRole.value
          }, {
            'is-selected-lead': role.id === selectedRole.value && role['is_lead'] === '1'
          }]),
          onClick: $event => selectedCard(role.id)
        }, [role['avatar'] ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
          src: role['avatar'],
          alt: "",
          class: "bg-image"
        }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), _createVNode(_component_el_image, {
          src: role['avatar'],
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("text", _hoisted_6, _toDisplayString(role['nickname']), 1), role.id !== selectedRole.value ? (_openBlock(), _createElementBlock("text", _hoisted_7, " 持有：" + _toDisplayString(parseFloat(role['wealth_point']).toFixed(1)) + " / 200 ", 1)) : _createCommentVNode("", true)])], 10, _hoisted_2);
      }), 128)), user.value && user.value.roles_numbers > roleArray.value.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "create-role-card",
        onClick: _cache[0] || (_cache[0] = $event => emits('open-role-generator'))
      }, [_createVNode(_component_el_icon, {
        size: "16"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Plus))]),
        _: 1
      }), _cache[1] || (_cache[1] = _createElementVNode("text", null, "创建链接角色", -1))])) : _createCommentVNode("", true)]);
    };
  }

};